export default __webpack_public_path__ + "assets/2fd5445de768367bfcff45d3109b4faf.png";